import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const partnerCategories = [
  {
    category: '战略科技合作',
    color: '#00FFCC',
    icon: 'ri-rocket-2-line',
    partners: [
      { name: 'Qualcomm', desc: '6G芯片战略合作', icon: 'ri-cpu-line', country: '🇺🇸' },
      { name: 'NVIDIA', desc: 'AI与XR渲染引擎', icon: 'ri-gamepad-line', country: '🇺🇸' },
      { name: 'Samsung', desc: 'XR硬件生态合作', icon: 'ri-smartphone-line', country: '🇰🇷' },
      { name: 'Huawei', desc: '6G网络基础设施', icon: 'ri-signal-tower-line', country: '🇨🇳' },
      { name: 'Microsoft', desc: 'Azure元宇宙云服务', icon: 'ri-cloud-line', country: '🇺🇸' },
      { name: 'Sony', desc: 'VR硬件与内容生态', icon: 'ri-glasses-line', country: '🇯🇵' },
      { name: 'Meta', desc: 'XR生态互联互通', icon: 'ri-glasses-2-line', country: '🇺🇸' },
      { name: 'Apple', desc: '空间计算生态合作', icon: 'ri-apple-line', country: '🇺🇸' },
    ],
  },
  {
    category: '国内顶级机构',
    color: '#FFD700',
    icon: 'ri-building-2-line',
    partners: [
      { name: '中国移动', desc: '5G/6G网络基础设施', icon: 'ri-signal-tower-line', country: '🇨🇳' },
      { name: '中国电信', desc: '云网融合战略合作', icon: 'ri-cloud-line', country: '🇨🇳' },
      { name: '腾讯', desc: '数字内容与社交生态', icon: 'ri-gamepad-line', country: '🇨🇳' },
      { name: '阿里巴巴', desc: '云计算与数字经济', icon: 'ri-store-line', country: '🇨🇳' },
      { name: '百度', desc: 'AI与自动驾驶生态', icon: 'ri-brain-line', country: '🇨🇳' },
      { name: '字节跳动', desc: 'XR内容与创作生态', icon: 'ri-video-line', country: '🇨🇳' },
      { name: '中科院', desc: '量子计算研究合作', icon: 'ri-flask-line', country: '🇨🇳' },
      { name: '清华大学', desc: '脑机接口联合研究', icon: 'ri-graduation-cap-line', country: '🇨🇳' },
    ],
  },
  {
    category: '区块链与Web3生态',
    color: '#FF6B9D',
    icon: 'ri-links-line',
    partners: [
      { name: 'Ethereum', desc: 'Web3.0基础协议', icon: 'ri-coin-line', country: '🌐' },
      { name: 'Polkadot', desc: '跨链互操作协议', icon: 'ri-links-line', country: '🌐' },
      { name: 'Solana', desc: '高性能区块链生态', icon: 'ri-flashlight-line', country: '🌐' },
      { name: 'Chainlink', desc: '去中心化预言机', icon: 'ri-links-line', country: '🌐' },
      { name: 'IPFS/Filecoin', desc: '去中心化存储网络', icon: 'ri-database-2-line', country: '🌐' },
      { name: 'Binance', desc: '数字资产交易生态', icon: 'ri-exchange-line', country: '🌐' },
    ],
  },
  {
    category: '顶级投资机构',
    color: '#A855F7',
    icon: 'ri-funds-line',
    partners: [
      { name: 'Sequoia Capital', desc: '红杉资本战略投资', icon: 'ri-funds-line', country: '🇺🇸' },
      { name: 'a16z', desc: 'Web3专项基金', icon: 'ri-building-4-line', country: '🇺🇸' },
      { name: '软银愿景基金', desc: '元宇宙战略布局', icon: 'ri-eye-line', country: '🇯🇵' },
      { name: '高瓴资本', desc: '科技创新战略投资', icon: 'ri-bar-chart-line', country: '🇨🇳' },
      { name: '红杉中国', desc: '数字经济生态投资', icon: 'ri-leaf-line', country: '🇨🇳' },
      { name: 'IDG资本', desc: '前沿科技早期投资', icon: 'ri-lightbulb-line', country: '🇨🇳' },
    ],
  },
  {
    category: '全球研究机构',
    color: '#FF6B35',
    icon: 'ri-flask-line',
    partners: [
      { name: 'MIT Media Lab', desc: '媒体技术前沿研究', icon: 'ri-graduation-cap-line', country: '🇺🇸' },
      { name: 'Stanford HAI', desc: '人机交互研究院', icon: 'ri-brain-line', country: '🇺🇸' },
      { name: 'DeepMind', desc: 'AGI与AI安全研究', icon: 'ri-robot-line', country: '🇬🇧' },
      { name: 'OpenAI', desc: 'AI智能体核心技术', icon: 'ri-sparkling-line', country: '🇺🇸' },
      { name: '北京大学', desc: '数字经济与元宇宙研究', icon: 'ri-book-open-line', country: '🇨🇳' },
      { name: '香港科技大学', desc: 'XR与空间计算研究', icon: 'ri-glasses-line', country: '🇨🇳' },
    ],
  },
];

const globalNodes = [
  { city: '深圳·大湾区', country: '中国', role: '全球总部 · 清鉴META大厦', status: 'active', color: '#00FFCC' },
  { city: '上海', country: '中国', role: '研发中心', status: 'active', color: '#00FFCC' },
  { city: '北京', country: '中国', role: '政策研究院', status: 'active', color: '#00FFCC' },
  { city: '香港', country: '中国', role: 'Web3生态中心', status: 'active', color: '#00FFCC' },
  { city: '新加坡', country: '新加坡', role: '亚太运营中心', status: 'active', color: '#FFD700' },
  { city: '东京', country: '日本', role: 'XR技术实验室', status: 'active', color: '#FFD700' },
  { city: '首尔', country: '韩国', role: '内容生态中心', status: 'active', color: '#FFD700' },
  { city: '旧金山', country: '美国', role: 'Web5.0研究院', status: 'active', color: '#FF6B9D' },
  { city: '纽约', country: '美国', role: '数字金融中心', status: 'building', color: '#A855F7' },
  { city: '伦敦', country: '英国', role: '欧洲运营中心', status: 'building', color: '#A855F7' },
  { city: '迪拜', country: '阿联酋', role: '中东生态中心', status: 'building', color: '#A855F7' },
  { city: '悉尼', country: '澳大利亚', role: '大洋洲节点', status: 'building', color: '#A855F7' },
];

export default function Partners() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: partnersRef, isVisible: partnersVisible } = useScrollAnimation({ threshold: 0.05 });
  const { ref: nodesRef, isVisible: nodesVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="partners" className="relative py-24 md:py-32 overflow-hidden" style={{ background: '#040C10' }}>
      {/* Doodle background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full opacity-4" style={{ background: 'radial-gradient(ellipse, #00FFCC 0%, transparent 70%)' }} />
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, rgba(0,255,200,0.04) 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }} />
        {/* Doodle splats */}
        <div className="absolute top-20 left-10 w-48 h-48 opacity-6" style={{ background: 'radial-gradient(ellipse, rgba(255,215,0,0.15) 0%, transparent 70%)', borderRadius: '60% 40% 55% 45% / 45% 55% 40% 60%' }} />
        <div className="absolute bottom-20 right-10 w-36 h-36 opacity-6" style={{ background: 'radial-gradient(ellipse, rgba(168,85,247,0.12) 0%, transparent 70%)', borderRadius: '45% 55% 40% 60% / 60% 40% 55% 45%' }} />
      </div>

      {/* Doodle wave top */}
      <svg className="absolute top-0 left-0 w-full" height="6" viewBox="0 0 1440 6" preserveAspectRatio="none">
        <path d="M0,3 Q90,0 180,3 Q270,6 360,3 Q450,0 540,3 Q630,6 720,3 Q810,0 900,3 Q990,6 1080,3 Q1170,0 1260,3 Q1350,6 1440,3" stroke="rgba(0,255,200,0.15)" strokeWidth="1.5" fill="none"/>
      </svg>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-16 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div
            className="inline-flex items-center gap-2 px-5 py-2 mb-6"
            style={{
              border: '1.5px dashed rgba(0,255,200,0.35)',
              borderRadius: '50% 45% 55% 50% / 50% 55% 45% 50%',
              background: 'rgba(0,255,200,0.04)',
            }}
          >
            <i className="ri-global-line text-sm" style={{ color: '#00FFCC' }} />
            <span className="text-xs font-bold tracking-widest uppercase" style={{ color: '#00FFCC', fontFamily: 'Caveat, cursive' }}>Global Partners</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-5" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            全球生态
            <span className="relative inline-block mx-3">
              <span className="text-transparent bg-clip-text" style={{ backgroundImage: 'linear-gradient(135deg, #00FFCC, #FFD700)' }}>伙伴</span>
              <svg className="absolute -bottom-2 left-0 w-full" height="6" viewBox="0 0 100 6" preserveAspectRatio="none">
                <path d="M0,3 Q25,0 50,3 Q75,6 100,3" stroke="#FFD700" strokeWidth="2" fill="none" strokeLinecap="round"/>
              </svg>
            </span>
          </h2>
          <p className="text-white/40 text-base max-w-3xl mx-auto leading-relaxed">
            汇聚全球顶级科技企业、国内一线机构、区块链生态、投资机构与研究院，
            共同构建元宇宙时代最强大的生态网络
          </p>
          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-8 mt-8">
            {[
              { value: '50+', label: '战略合作伙伴', color: '#00FFCC' },
              { value: '12', label: '全球节点城市', color: '#FFD700' },
              { value: '5大洲', label: '生态覆盖', color: '#FF6B9D' },
              { value: '$50亿+', label: '生态总估值', color: '#A855F7' },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1">
                <span className="text-2xl font-black" style={{ fontFamily: 'Orbitron, sans-serif', color: s.color }}>{s.value}</span>
                <span className="text-white/35 text-xs">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Partner Categories */}
        <div
          ref={partnersRef as React.RefObject<HTMLDivElement>}
          className={`flex flex-col gap-12 mb-20 transition-all duration-700 delay-150 ${partnersVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {partnerCategories.map((cat) => (
            <div key={cat.category}>
              <div className="flex items-center gap-3 mb-6">
                <div
                  className="w-8 h-8 flex items-center justify-center flex-shrink-0"
                  style={{
                    background: `${cat.color}15`,
                    borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                  }}
                >
                  <i className={`${cat.icon} text-sm`} style={{ color: cat.color }} />
                </div>
                <h3 className="text-white font-bold text-lg" style={{ fontFamily: 'Caveat, cursive', fontSize: '1.2rem' }}>{cat.category}</h3>
                <div className="flex-1 h-px" style={{ background: `${cat.color}20` }} />
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
                {cat.partners.map((p) => (
                  <div
                    key={p.name}
                    className="group flex flex-col items-center gap-2.5 p-4 transition-all duration-300 hover:-translate-y-1.5 cursor-pointer text-center"
                    style={{
                      border: `1px solid rgba(255,255,255,0.07)`,
                      borderRadius: '12px 8px 14px 10px / 10px 14px 8px 12px',
                      background: 'rgba(255,255,255,0.02)',
                    }}
                    onMouseEnter={(e) => {
                      (e.currentTarget as HTMLElement).style.borderColor = `${cat.color}30`;
                      (e.currentTarget as HTMLElement).style.background = `${cat.color}06`;
                    }}
                    onMouseLeave={(e) => {
                      (e.currentTarget as HTMLElement).style.borderColor = 'rgba(255,255,255,0.07)';
                      (e.currentTarget as HTMLElement).style.background = 'rgba(255,255,255,0.02)';
                    }}
                  >
                    <div
                      className="w-10 h-10 flex items-center justify-center transition-all duration-300"
                      style={{
                        background: 'rgba(255,255,255,0.05)',
                        borderRadius: '50% 40% 60% 45% / 45% 60% 40% 55%',
                      }}
                    >
                      <i className={`${p.icon} text-white/35 group-hover:text-white/80 text-lg transition-colors duration-300`} style={{ color: undefined }} />
                    </div>
                    <div>
                      <p className="text-white font-bold text-xs leading-tight">{p.name}</p>
                      <p className="text-white/25 text-xs mt-0.5 leading-tight">{p.desc}</p>
                    </div>
                    <span className="text-xs opacity-60">{p.country}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Global Nodes */}
        <div
          ref={nodesRef as React.RefObject<HTMLDivElement>}
          className={`pt-16 transition-all duration-700 delay-200 ${nodesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          style={{ borderTop: '1px solid rgba(0,255,200,0.1)' }}
        >
          <div className="flex flex-col lg:flex-row gap-12 items-start">
            {/* Map Visual */}
            <div className="flex-1">
              <h3 className="text-2xl font-bold text-white mb-8" style={{ fontFamily: 'Caveat, cursive', fontSize: '1.6rem' }}>
                ✦ 全球<span style={{ color: '#00FFCC' }}>节点</span>布局
              </h3>
              <div
                className="relative rounded-2xl overflow-hidden"
                style={{
                  border: '1.5px solid rgba(0,255,200,0.2)',
                  height: '280px',
                }}
              >
                <img
                  src="https://public.readdy.ai/ai/img_res/93cfd5f4658840ae3b926bc79519c707.jpg"
                  alt="全球节点地图"
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(4,12,16,0.7) 0%, transparent 50%)' }} />
                <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(4,12,16,0.4) 0%, transparent 30%, transparent 70%, rgba(4,12,16,0.4) 100%)' }} />
                {/* Animated dots */}
                {[
                  { top: '35%', left: '72%' }, { top: '30%', left: '75%' }, { top: '28%', left: '70%' },
                  { top: '32%', left: '80%' }, { top: '38%', left: '82%' }, { top: '25%', left: '20%' },
                  { top: '40%', left: '48%' }, { top: '55%', left: '55%' }, { top: '45%', left: '62%' },
                  { top: '60%', left: '80%' }, { top: '50%', left: '52%' }, { top: '42%', left: '68%' },
                ].map((pos, i) => (
                  <div
                    key={i}
                    className="absolute w-2 h-2 rounded-full"
                    style={{
                      top: pos.top, left: pos.left,
                      background: i < 8 ? '#00FFCC' : 'rgba(168,85,247,0.7)',
                      boxShadow: `0 0 8px ${i < 8 ? 'rgba(0,255,200,0.8)' : 'rgba(168,85,247,0.6)'}`,
                      animation: `pulse ${1.5 + i * 0.2}s ease-in-out infinite`,
                    }}
                  />
                ))}
                <div className="absolute bottom-4 left-4 flex items-center gap-4">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full" style={{ background: '#00FFCC', boxShadow: '0 0 6px rgba(0,255,200,0.8)' }} />
                    <span className="text-white/60 text-xs">运营中</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full" style={{ background: 'rgba(168,85,247,0.7)' }} />
                    <span className="text-white/60 text-xs">建设中</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Node List */}
            <div className="w-full lg:w-96 flex flex-col gap-2">
              <h3 className="text-lg font-bold text-white mb-3" style={{ fontFamily: 'Caveat, cursive', fontSize: '1.2rem' }}>节点详情</h3>
              <div className="grid grid-cols-1 gap-2 max-h-[320px] overflow-y-auto pr-1">
                {globalNodes.map((node) => (
                  <div
                    key={node.city}
                    className="flex items-center gap-3 p-3 transition-all duration-300"
                    style={{
                      border: '1px solid rgba(255,255,255,0.06)',
                      borderRadius: '8px 6px 10px 8px / 6px 10px 8px 6px',
                      background: 'rgba(255,255,255,0.02)',
                    }}
                  >
                    <div
                      className="w-2 h-2 rounded-full flex-shrink-0"
                      style={{
                        background: node.status === 'active' ? node.color : 'rgba(168,85,247,0.5)',
                        boxShadow: node.status === 'active' ? `0 0 6px ${node.color}80` : 'none',
                      }}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="text-white text-sm font-semibold">{node.city}</span>
                        <span className="text-white/25 text-xs">{node.country}</span>
                      </div>
                      <p className="text-white/35 text-xs mt-0.5">{node.role}</p>
                    </div>
                    <span
                      className="text-xs font-semibold whitespace-nowrap"
                      style={{
                        color: node.status === 'active' ? node.color : 'rgba(168,85,247,0.6)',
                        fontFamily: 'Caveat, cursive',
                      }}
                    >
                      {node.status === 'active' ? '✦ 运营中' : '○ 建设中'}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
